// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"13af7e41","111":"2b04c224","135":"7bff80a9","145":"ba5792cf","381":"727a37b7","441":"43956f6c","481":"89555d29","488":"371f7511","595":"7248433d","601":"3591f662","615":"af04fba7","654":"ac56ae0b","730":"a1b69420","793":"4577f221","833":"f26bda74","946":"da993eb1"}[chunkId] + ".chunk.js";
};